import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'
import { PublicInterceptor } from '../../../Base/interceptors/PublicInterceptor';


//--------------------------------------------OBTENER----------------------------------------

export const getKnitCost = async () =>{
    const result = await PrivateInterceptor(`Ventas/Cotizaciones/getKnitCost`, 'GET');
    return result;
}

export const getDyeCost = async () =>{
    const result = await PrivateInterceptor(`Ventas/Cotizaciones/getDyeCost`, 'GET');
    return result;
}

export const getAdditionalCost = async () =>{
    const result = await PrivateInterceptor(`Ventas/Cotizaciones/getAdditionalCost`, 'GET');
    return result;
}

export const getOtherCost = async () =>{
    const result = await PrivateInterceptor(`Ventas/Cotizaciones/getOtherCost`, 'GET');
    return result;
}

//----------------------------------------AGREGAR Y EDITAR--------------------------------------
export const GuardarKnitCost = (Datos) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/GuardarKnitCost", "POST", {Datos});
    return respuesta;
};

export const EditarKnitCost = (Datos) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/EditarKnitCost", "POST", {Datos});
    return respuesta;
};


export const GuardarDyeCost = (Datos) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/GuardarDyeCost", "POST", {Datos});
    return respuesta;
};

export const EditarDyeCost = (Datos) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/EditarDyeCost", "POST", {Datos});
    return respuesta;
};

export const GuardarAdditionalCost = (Datos) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/GuardarAdditionalCost", "POST", {Datos});
    return respuesta;
};

export const EditarAdditionalCost = (Datos) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/EditarAdditionalCost", "POST", {Datos});
    return respuesta;
};


//-------------------------------------------- PRINCIPALES ---------------------------------------

export const getCotizacionesEnc = async (data) => {
    return await PrivateInterceptor("Ventas/Cotizaciones/Encabezado", "POST", data);
};

export const getCotizacionesDet = async (data) => {
    return await PrivateInterceptor("Ventas/Cotizaciones/Detalle", "POST", data);
};

export const ObtenerSiguienteNoCotizacion = () => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/ObtenerSiguienteNoCotizacion", "GET");
    return respuesta;
};

export const getEncabezadoPorId = async (IdQuotation) => {
    return await PrivateInterceptor("Ventas/Cotizaciones/EncabezadoPorId", "POST", {IdQuotation});
};

export const getDetallePorId = async (IdQuotation) => {
    return await PrivateInterceptor("Ventas/Cotizaciones/DetallesPorId", "POST", {IdQuotation});
};


export const getEncabezadoPorQuotation = async (Quotation) => {
    return await PrivateInterceptor("Ventas/Cotizaciones/EncabezadoPorQuotation", "POST", {Quotation});
};

export const getDetallePorQuotation = async (Quotation) => {
    return await PrivateInterceptor("Ventas/Cotizaciones/DetallesPorQuotation", "POST", {Quotation});
};

export const GuardarCotizacion = async (Encabezado, Detalles) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/GuardarCotizacion", "POST",{Encabezado, Detalles});
    return respuesta;
};

export const EditarCotizacion = async (Encabezado, Detalles) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/EditarCotizacion", "POST",{Encabezado, Detalles});
    return respuesta;
};

export const EliminarCosto = (data) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/EliminarCosto", "POST",{Detalles: data});
    return respuesta;
};

export const EliminarDetalles = (data) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/EliminarDetalles", "POST",{Detalles: data});
    return respuesta;
};

export const EliminarCotizacion = (data) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/EliminarCotizacion", "POST",{Encabezado: data});
    return respuesta;
};

export const getCotizacionesCompletas = async (data) => {
    return await PrivateInterceptor("Ventas/Cotizaciones/DatosCompletos", "POST", {data});
};

export const getNewLink = async (IdQuotation, languaje) => {
    const a = await PrivateInterceptor("Ventas/Cotizaciones/newLink", "POST", {IdQuotation, languaje});
    return a;
};
  
export const getCotizacionesPublic = async(IdFacturaProforma,token) =>{
    const result = await PublicInterceptor(`Ventas/Cotizaciones/DetallesPorId/Public`, 'POST', {IdFacturaProforma}, token);
    return result;
}


export const GuardarCotizacionSencilla = async (Encabezado, Detalles) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/GuardarCotizacionSencilla", "POST",{Encabezado, Detalles});
    return respuesta;
};

export const EditarCotizacionSencilla = async (Encabezado, Detalles) => {
    const respuesta = PrivateInterceptor("Ventas/Cotizaciones/EditarCotizacionSencilla", "POST",{Encabezado, Detalles});
    return respuesta;
};

// ------------------------------------ ARCHIVO ---------------------------------------

export const getCotizacionSubida = async(Quotation, Token) => {
    const respuesta = await PublicInterceptor(`Ventas/Cotizaciones/getArchivo/` + Quotation, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoSubido = async (Quotation, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Ventas/Cotizaciones/descargarArchivo/${Quotation}/${nombre}`, 'GET', {} , Token)
    return respuesta;
}

export const eliminarArchivoSubido = async (Quotation, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Ventas/Cotizaciones/eliminarArchivo/${Quotation}`, 'DELETE', {nombre} , Token)
    return respuesta;
}

export const getStyleCategory = async () =>{
    const result = await PrivateInterceptor(`Ventas/Cotizaciones/getStyleCategory`, 'GET');
    return result;
}

export const getAdditional = async () =>{
    const result = await PrivateInterceptor(`Ventas/Cotizaciones/getAdditional`, 'GET');
    return result;
}
